import ymaps from "ymaps";

function initYaMaps() {
    const map = document.querySelector(".js-init-yamap");

    if (map && !map.classList.contains("map-initialized")) {
        const centerCoords = map.dataset.coordsCenter?.split(",");
        const baloonCoords = map.dataset.baloonCoords.split(",");
        const baloonTitle = map.dataset.baloonTitle;
        const baloonText = map.dataset.baloonText;
        const baloonContacts = map.dataset.baloonContacts.split(",").join("");

        const baloonContent = `
            <div class="map-popup">
                <div class="map-popup__title">${baloonTitle}</div>
                <div class="map-popup__text">${baloonText}</div>
                <div class="map-popup__phones">${baloonContacts}</div>
            </div>
        `;
        const mapCenter = () => {
            return window.mobileMedia ? baloonCoords : centerCoords || baloonCoords;
        };

        ymaps.load("https://api-maps.yandex.ru/2.1/?lang=ru_RU").then((maps) => {
            const newMap = new maps.Map(
                map,
                {
                    center: mapCenter(),
                    zoom: 15,
                },
                {
                    searchControlProvider: "yandex#search",
                },
            );

            newMap.controls.remove("searchControl");
            newMap.behaviors.disable("scrollZoom");

            if (!window.mobileMedia) {
                newMap.balloon.open(
                    baloonCoords,
                    {
                        contentBody: baloonContent,
                    },
                    {
                        closeButton: false,
                    },
                );
            }

            const newPlacemark = new maps.Placemark(
                baloonCoords,
                {
                    balloonContent: baloonContent,
                },
                {
                    preset: "islands#redIcon",
                },
            );

            newMap.geoObjects.add(newPlacemark);

            // ловлю багу с повторным кликом по содержимому балуна
            newPlacemark.balloon.events.add("open", () => {
                setTimeout(() => {
                    const phones = document.querySelector(".map-popup__phones");

                    if (phones) {
                        phones.style.pointerEvents = "all";
                    }
                }, 500);
            });

            map.classList.add("map-initialized");
        });
    }
}

window.addEventListener("load", initYaMaps());
